var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2202",
    "data-name": "Group 2202",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 207.287,
    height: 33.444,
    viewBox: "0 0 207.287 33.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1017",
    "data-name": "Rectangle 1017",
    width: 207.287,
    height: 33.444,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M815.317,43.8l-3.063-5.081h3.063Z",
    transform: "translate(-671.945 -32.03)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M865.78,43.8V38.718h3.044Z",
    transform: "translate(-716.226 -32.03)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M815.317,84.784l-3.063,5.1h3.063Z",
    transform: "translate(-671.945 -70.139)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M865.78,84.784l3.044,5.1H865.78Z",
    transform: "translate(-716.226 -70.139)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M816.183,45.235l-3.929-6.516V51.776Z",
    transform: "translate(-671.946 -32.031)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M860.66,45.235l3.929-6.516V51.776Z",
    transform: "translate(-711.99 -32.031)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M835.288,76.457h-4.436l-.864,1.438h6.163Z",
    transform: "translate(-686.617 -63.25)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M835.288,69.579h-4.436l-.864-1.438h6.163Z",
    transform: "translate(-686.617 -56.37)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M816.183,45.235l-3.929-6.516V51.776Z",
    transform: "translate(-671.946 -32.031)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M196.935,0,184.7,6.835l-.646-3.368-2.813-2.3V24.318l14.17-7.392L212.554,27.3Z",
    transform: "translate(-149.937 0)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M184.44,11.074l-.383-1.995-2.813-2.3V15.12Z",
    transform: "translate(-149.937 -5.612)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M181.246,123.132v10.813l3.483,1.3-.777-12.188Z",
    transform: "translate(-149.937 -101.798)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2122",
    "data-name": "Group 2122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2121",
    "data-name": "Group 2121",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M182.766,12.7l1.507-8.108.431,2.245L196.935,0l-1.52,16.926-14.17,7.392v-11.2c.856-.235,1.521-.424,1.521-.424",
    transform: "translate(-149.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M181.245,6.784V7.7l2.813,1.381Z",
    transform: "translate(-149.937 -5.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M181.245,177.5v1.486l3.483,1.3Z",
    transform: "translate(-149.937 -146.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M184.7,23.439l-3.459,2.707,2.813-6.074Z",
    transform: "translate(-149.937 -16.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M184.7,39.566l1.66,7.776-2.31,8.243-2.808,1.465V42.24Z",
    transform: "translate(-149.937 -32.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M208.864,86.9l-9.051-2.315-2.31,8.243Z",
    transform: "translate(-163.386 -69.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M220.513,60.3l-.585,6.51-9.051-2.315Z",
    transform: "translate(-174.451 -49.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M181.245,133.762l3.483,9.126-.675-10.591Z",
    transform: "translate(-149.937 -109.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M263.859,60.3l16.554,16.887L263.274,66.808Z",
    transform: "translate(-217.796 -49.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M186.364,84.581l-5.119,9.707,2.808-1.465Z",
    transform: "translate(-149.937 -69.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M269.935,66.5l-6.661.311.585-6.51Z",
    transform: "translate(-217.796 -49.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M307.448,98.367l-5.611-2.181,10.477,10.688Z",
    transform: "translate(-249.698 -79.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M17.139,16.926,0,27.3,15.619,0,27.85,6.835,28.5,3.467l2.813-2.3V24.318Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M162.746,11.074l.383-1.995,2.813-2.3V15.12Z",
    transform: "translate(-134.633 -5.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M164.565,123.133v10.813l-3.483,1.3.776-12.188Z",
    transform: "translate(-133.257 -101.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M104.586,12.7,103.078,4.59l-.431,2.245L90.417,0l1.52,16.926,14.17,7.392v-11.2c-.856-.235-1.521-.424-1.521-.424",
    transform: "translate(-74.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M167.774,6.784V7.7l-2.813,1.381Z",
    transform: "translate(-136.466 -5.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M164.565,177.5v1.486l-3.483,1.3Z",
    transform: "translate(-133.257 -146.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M161.221,23.439l3.459,2.707-2.813-6.074Z",
    transform: "translate(-133.372 -16.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M99.215,86.9l9.051-2.315,2.31,8.243Z",
    transform: "translate(-82.077 -69.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M95.831,60.3l.585,6.51,9.051-2.315Z",
    transform: "translate(-79.278 -49.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M164.565,133.762l-3.483,9.126.675-10.591Z",
    transform: "translate(-133.257 -109.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M16.554,60.3,0,77.185,17.139,66.808Z",
    transform: "translate(0 -49.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M151.613,84.581l5.119,9.707-2.808-1.465Z",
    transform: "translate(-125.423 -69.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M60.653,66.5l6.661.311L66.73,60.3Z",
    transform: "translate(-50.176 -49.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M4.866,98.367l5.611-2.181L0,106.874Z",
    transform: "translate(0 -79.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M186.378,47.342l-5.119-1.488V42.239l3.459-2.673Z",
    transform: "translate(-149.949 -32.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M186.366,77.452l-5.119-1.489,0,11.2Z",
    transform: "translate(-149.936 -62.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M151.636,77.452l5.119-1.489,0,11.2Z",
    transform: "translate(-125.442 -62.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M90.417,0l12.231,6.835-1.66,7.776-9.636-4.195Z",
    transform: "translate(-74.798 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M151.613,47.342l5.119-1.488V42.239l-3.459-2.673Z",
    transform: "translate(-125.423 -32.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M395,43.892l-3.063-5.174h2.335Z",
    transform: "translate(-324.231 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M444.81,84.244l.71,5.193h2.335Z",
    transform: "translate(-367.974 -69.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M444.81,38.718h3.045V51.775l-3.045-5.193Z",
    transform: "translate(-367.974 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M395,68.67v7.883h-3.063Z",
    transform: "translate(-324.231 -56.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M444.81,46.582l3.045-7.864H444.81Z",
    transform: "translate(-367.974 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M409.667,68.67l6.071,2.69.71,5.193Z",
    transform: "translate(-338.901 -56.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M405.45,38.718l.728,5.174,6.071,2.69Z",
    transform: "translate(-335.413 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M492.777,104.378l-1.532-2.073-1.531,2.073Z",
    transform: "translate(-405.121 -84.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M491.245,49.7V40.791l-1.532-2.073V51.775Z",
    transform: "translate(-405.121 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M500.11,38.718l-1.531,2.073V49.7l1.532,2.073Z",
    transform: "translate(-412.454 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M1014.931,89.107l-1.606,4.353h3.12Z",
    transform: "translate(-838.283 -73.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M1067.284,89.107l-1.513,4.353h3.119Z",
    transform: "translate(-881.671 -73.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M1041.243,43.033l-1.531-4.315h3.063Z",
    transform: "translate(-860.113 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M1022.623,47.422l4.483-4.389-1.531-4.315Z",
    transform: "translate(-845.976 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M989.319,38.718l5.753,8.7-2.783-8.7Z",
    transform: "translate(-818.425 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M989.319,38.718l5.753,8.7-1.606,4.353Z",
    transform: "translate(-818.425 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M1022.623,68.086l4.483-4.389-2.97,8.742Z",
    transform: "translate(-845.976 -52.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M1050.109,38.718l-1.532,4.315,4.483,4.389Z",
    transform: "translate(-867.446 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M1053.06,68.086l-4.483-4.389,2.97,8.742Z",
    transform: "translate(-867.447 -52.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M1080.283,38.718l-5.753,8.7,1.606,4.353Z",
    transform: "translate(-888.917 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M1080.283,38.718h-2.988l-2.765,8.7Z",
    transform: "translate(-888.917 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M1129.422,44.21V38.719h-3.063Z",
    transform: "translate(-931.792 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M1163.556,44.7l1.85-5.977h3.81Z",
    transform: "translate(-962.564 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M1144.093,74.543V70.508l1.382,2.578Z",
    transform: "translate(-946.463 -58.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M1147.455,44.7l-3.362-.486,5.212-5.491Z",
    transform: "translate(-946.463 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M1145.475,73.087l1.98-2.092-3.362-.486Z",
    transform: "translate(-946.463 -58.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M1129.422,70.509l-3.063,7.565h3.063Z",
    transform: "translate(-931.792 -58.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M1152.093,85.434l8.275,4.987h-3.848Z",
    transform: "translate(-953.081 -70.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M1160.368,80.4l-6.3-7.08-1.98,2.092Z",
    transform: "translate(-953.081 -60.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M1126.359,38.718l3.063,5.491-3.063,7.565Z",
    transform: "translate(-931.792 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M933.416,41.688l-1.869-2.97h3.736Z",
    transform: "translate(-770.633 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M933.238,41.688l-1.869-2.97-.037,7.7Z",
    transform: "translate(-770.455 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M906.464,46.414l-5.193,5.361,5.23-13.057Z",
    transform: "translate(-745.586 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M901.271,88.631h3.063l2.13-5.361Z",
    transform: "translate(-745.586 -68.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M944.251,46.414l-.018-7.7-1.868,2.97Z",
    transform: "translate(-779.582 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M953.178,38.718l5.211,13.057L953.2,46.414Z",
    transform: "translate(-788.527 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M955.432,88.631h3.044l-5.193-5.361Z",
    transform: "translate(-788.614 -68.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M931.333,83.27l1.906,2.666,1.886-2.666Z",
    transform: "translate(-770.455 -68.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M928.163,85.936H925.2l1.06-2.666Z",
    transform: "translate(-765.38 -68.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M945.315,85.923l-2.951.013,1.886-2.666Z",
    transform: "translate(-779.581 -68.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M722.477,38.718l4.39,2.839h-4.39Z",
    transform: "translate(-597.677 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M765.624,41.557l4.389-2.839v2.839Z",
    transform: "translate(-633.371 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M734.319,38.718H722.477l5.922,3.83Z",
    transform: "translate(-597.677 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M750.954,104.378l-1.532-2.073-1.531,2.073Z",
    transform: "translate(-618.7 -84.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M749.422,63.3V56.145l-1.532-.991V65.372l1.531-2.073Z",
    transform: "translate(-618.7 -45.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M756.758,56.144V63.3l1.532,2.072V55.154Z",
    transform: "translate(-626.036 -45.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M633.17,43.8l-3.063-5.081h3.063Z",
    transform: "translate(-521.262 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M683.633,43.8V38.718h3.044Z",
    transform: "translate(-565.543 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M633.17,84.784l-3.063,5.1h3.063Z",
    transform: "translate(-521.262 -70.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M683.633,84.784l3.044,5.1h-3.044Z",
    transform: "translate(-565.543 -70.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M634.036,45.235l-3.929-6.516V51.776Z",
    transform: "translate(-521.263 -32.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M678.513,45.235l3.929-6.516V51.776Z",
    transform: "translate(-561.307 -32.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M653.141,76.457h-4.436l-.864,1.438H654Z",
    transform: "translate(-535.934 -63.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M653.141,69.579h-4.436l-.864-1.438H654Z",
    transform: "translate(-535.934 -56.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M634.036,45.235l-3.929-6.516V51.776Z",
    transform: "translate(-521.263 -32.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M489.714,38.718l1.532,2.073,1.531-2.073Z",
    transform: "translate(-405.121 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M391.932,38.718V51.775L395,43.892Z",
    transform: "translate(-324.23 -32.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M588.559,47.494,587.4,46.144l-1.868,2.075.654.733Z",
    transform: "translate(-484.388 -38.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M583.917,42.043l-1.188-.856-1.408,2.439.728.493Z",
    transform: "translate(-480.904 -34.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M578.846,38.5l-1.349-.561-.87,2.678.811.322Z",
    transform: "translate(-477.022 -31.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M573.415,36.487l-1.425-.3-.3,2.836.853.145Z",
    transform: "translate(-472.939 -29.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M558.163,36.185l.3,2.863-.836.178-.89-2.738Z",
    transform: "translate(-460.568 -29.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M544.7,43.888l-1.455-2.521-1.21.821,1.991,2.211Z",
    transform: "translate(-448.403 -34.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M535.309,54.267l-2.417-1.756-.746,1.259,2.774,1.235Z",
    transform: "translate(-440.223 -43.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M531.837,68.535l-2.945-.626-.18,1.448h3.049Z",
    transform: "translate(-437.383 -56.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M532.713,81.292l-2.96.585.422,1.385,2.765-1.219Z",
    transform: "translate(-438.243 -67.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M538.914,89.877l-2.421,1.749.988,1.082,1.968-2.185Z",
    transform: "translate(-443.82 -74.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M550.5,96.563,549.036,99.1l1.331.592.9-2.756Z",
    transform: "translate(-454.196 -79.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M565.288,99.766l-.3,2.874h1.457l-.3-2.856Z",
    transform: "translate(-467.39 -82.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M576.628,97.46l.87,2.678,1.331-.592-1.408-2.438Z",
    transform: "translate(-477.022 -80.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M585.282,90.908,587.141,93l.952-1.082-2.287-1.688Z",
    transform: "translate(-484.181 -74.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M590.292,84.9l2.652,1.124.414-1.347Z",
    transform: "translate(-488.326 -70.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M593.5,76.521l-3.213,1.633,3.066-.224Z",
    transform: "translate(-488.325 -63.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M588.649,85.991l.005-.016,2.652,1.124-.708,1.3-2.287-1.688Z",
    transform: "translate(-486.688 -71.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M581.919,94.154l1.859,2.092-1.153.856-1.408-2.438Z",
    transform: "translate(-480.818 -77.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M572.534,99.15l.87,2.678-1.424.3-.3-2.856Z",
    transform: "translate(-472.928 -82.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M558.465,98.881l-.3,2.874-1.425-.3.9-2.756Z",
    transform: "translate(-460.568 -81.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M544.855,94.124l-1.462,2.532-1.178-.856,1.968-2.185Z",
    transform: "translate(-448.553 -77.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M535.359,86.374l-2.421,1.749-.742-1.261,2.765-1.219Z",
    transform: "translate(-440.265 -70.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M531.852,77.157l-2.96.585-.18-1.449h3.049Z",
    transform: "translate(-437.383 -63.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M532.7,61.824l.243-.792L530.165,59.8l-.414,1.4Z",
    transform: "translate(-438.243 -49.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M538.883,48.982l.536-.648-1.991-2.211-.962,1.1Z",
    transform: "translate(-443.798 -38.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M550.491,41.051l.765-.375-.89-2.739-1.331.592Z",
    transform: "translate(-454.196 -31.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M565.287,39.047l.857-.027.3-2.836h-1.456Z",
    transform: "translate(-467.391 -29.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M593.486,70.834l-3.194,2.615,3.213-1.633Z",
    transform: "translate(-488.325 -58.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M572.453,70.834l3.082,2.615,3.194-2.615Z",
    transform: "translate(-473.568 -58.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M572.453,70.834l3.082,2.615h-3.082Z",
    transform: "translate(-473.568 -58.598)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.618c70d98e836fe82e1465e7c11f7641.svg";
export { ForwardRef as ReactComponent };